'use client';

import { AppBar, ErrorNotice } from '~/components';
import { SearchForm } from '~/app/search/_components';
import { usePreservedCallback } from '@bgzt/hooks';
import { debounce } from 'lodash-es';
import { useRouter } from 'next/navigation';
import { useQueryState } from 'nuqs';

type Props = {
  error: CustomError & { digest?: string };
  reset: () => void;
};

export default function Error({ reset }: Props) {
  const router = useRouter();
  const [q, setQ] = useQueryState('q');

  const routeToSearchResult = (value: string) => {
    router.push(`/search/result?q=${value}`);
  };

  const debounceSetQ = usePreservedCallback(
    debounce((value: string) => {
      setQ(value);
    }, 300),
  );

  const handleSearchInputChange = (value: string) => {
    debounceSetQ(value);
  };

  const handleSearchFormSubmit = (value: string) => {
    routeToSearchResult(value);
    // TODO: 최근 검색어 저장
  };

  return (
    <>
      <AppBar
        slot={
          <SearchForm value={q ?? ''} onChange={handleSearchInputChange} onSubmit={handleSearchFormSubmit} allowClear />
        }
      />
      <ErrorNotice
        onResetClick={() => {
          // Attempt to recover by trying to re-render the segment
          reset();
        }}
      />
    </>
  );
}
